module.exports = __webpack_public_path__ + "img/susan-b-anthony.881b774e.png";